export const dispatchLoaderEvent = ({ showLoader }: { showLoader: boolean }) => {
  const customEvent = new CustomEvent('yuno-loader-message', { detail: showLoader })
  document.dispatchEvent(customEvent)
}
